import React from 'react'

function Error(props) {
  return (
    <div className='errorMessage'>{props.Error}</div>
  )
}

export default Error